<template>
  <div id="app">
    <TheLayout>
      <router-view/>
    </TheLayout>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { FETCH_JOBS } from 'store/actions';
import TheLayout from 'components/TheLayout';

export default {
  name: 'App',
  components: {
    TheLayout,
  },
  created() {
    this.loadJobs();
  },
  methods: {
    ...mapActions({
      loadJobs: FETCH_JOBS,
    }),
  },
};
</script>

<style lang="scss">
@import 'styles/app';
</style>



// WEBPACK FOOTER //
// src/App.vue